document.addEventListener('DOMContentLoaded',  function() {
    const parents = document.querySelectorAll('.parent-collection');
    parents.forEach(function(parent) {
        const read_more = parent.querySelector('.coll-read-more');
        const excerpt = parent.querySelector('.excerpt');
        const full = parent.querySelector('.full');
        
        if( read_more != null) {
            read_more.addEventListener('click', function(e) {

                read_more.classList.toggle('active');
                excerpt.classList.toggle('hidden');
                full.classList.toggle('hidden');
                if (read_more.classList.contains('active')) {
                    read_more.innerHTML = 'Read less';
                } else {
                    read_more.innerHTML = 'Read more';
                }
            });
        }
    });
});